import moment from 'moment';
import _ from 'lodash';

import { SCHEDULE_DAILY_TIME_OFFSET_PRECISION } from '../brzw_calendar/constants';
import { DEPARTMENTS_PERMISSIONS } from './permissions';

/**
 * @type {String}
 */
export const TASK_ASSIGNMENT_TIME_PATH = 'start_time';

/**
 * @type {String}
 */
export const TASK_SCHEDULE_TIME_PATH = 'schedule.time';

/**
 * @type {String}
 */
export const TASK_ASSIGNMENT_DATE_PATH = 'start_date';

/**
 * @type {String}
 */
export const TASK_SCHEDULE_DATE_PATH = 'schedule.date';

/**
 * @type {String}
 */
export const TASK_ASSIGNMENT_TIME_FORMAT = 'hh:mm:ss';

/**
 * @type {String}
 */
export const TASK_TIME_SCALE_UNIT = 'minutes';

/**
 * @type {String}
 */
export const TASK_TIME_INCLUSIVITY = '[)';

/**
 * @type {Number}
 */
export const TASK_FINISH_TIME_VALUE = 2;

/**
 * @type {String}
 */
export const TASK_FINISH_TIME_UNIT = 'h';

/**
 * @type {Number}
 */
export const TASK_ROW_DEFAULT_WIDTH = 1;

/**
 * @type {Object}
 */
export const SINGLE_TASK_LIFE_STATUS = {
  ASSIGNED: 'assigned',
  FINISHED: 'finished',
  IN_PROGRESS: 'in_progress',
  OVERDUE: 'overdue',
  SCHEDULED: 'scheduled',
  UNASSIGNED: 'unassigned',
};

/**
 * @type {Object}
 */
export const TASK_ASSIGNMENT_STATUS = {
  ACCEPTED: 'accepted',
  ASSIGNED: 'assigned',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  PENDING: 'pending',
};

/**
 * @type {Object}
 */
export const TASK_AVAILABILITY_STATUS = {
  OVERBOOKED: 'overbooked',
  HAS_AVAILABILITY: 'has_availability',
  NO_AVAILABILITY_SET: 'no_availability_set',
  NEAR_CAPACITY: 'near_capacity',
};

/**
 * @type {Array}
 */
export const TASK_ASSIGNMENT_OPTIONS = [
  { code: TASK_ASSIGNMENT_STATUS.PENDING, name: 'Pending' },
  { code: TASK_ASSIGNMENT_STATUS.ASSIGNED, name: 'Assigned' },
  { code: TASK_ASSIGNMENT_STATUS.ACCEPTED, name: 'Accepted' },
  { code: TASK_ASSIGNMENT_STATUS.DECLINED, name: 'Declined' },
  { code: TASK_ASSIGNMENT_STATUS.EXPIRED, name: 'Expired' },
];

/**
 * @type {Array}
 */
export const TASK_DEPARTMENT_OPTIONS = [
  { code: 'housekeeping', name: 'Cleaning' },
  { code: 'inspection', name: 'Inspection' },
  { code: 'maintenance', name: 'Maintenance' },
];

/**
 * @type {Array}
 */
export const TASK_RATE_OPTIONS = [
  { label: 'Hourly Rate', value: 'hour' },
  { label: 'Piece Rate', value: 'flat' },
];

/**
 * @type {Array}
 */
export const TASK_RATE_NEW_OPTIONS = [
  { label: 'hourly', value: 'hour' },
  { label: 'piece', value: 'flat' },
];

/**
 * @type {Object}
 */
export const TASK_RATE_VALUES = {
  HOUR: 'hour',
  FLAT: 'flat',
};

/**
 * @type {Object}
 */
export const TASK_TYPE_STATUS = {
  APPROVED: 'approved',
  ASSIGNED: 'assigned',
  CLOSED: 'closed',
  CREATED: 'created',
  FINISHED: 'finished',
  IN_PROGRESS: 'in_progress',
  NEW: 'new',
};

/**
 * @type {Object}
 */
export const TASK_READY_TYPE_STATUS = {
  BLOCKED: 'blocked',
  CLEANED: 'cleaned',
  CLEANING: 'cleaning',
  DIRTY: 'dirty',
  IN_PROGRESS: 'in_progress',
  INSPECTED: 'inspected',
  INSPECTING: 'inspecting',
  OCCUPIED: 'occupied',
  READY: 'ready',
};

/**
 * @type {Object}
 */
export const TASK_PRIORITIES = {
  WATCH: 'watch',
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
};

/**
 * @type {Array}
 */
export const TASK_PRIORITY_OPTIONS = [
  { code: TASK_PRIORITIES.WATCH, name: 'Watch' },
  { code: TASK_PRIORITIES.LOW, name: 'Low' },
  { code: TASK_PRIORITIES.NORMAL, name: 'Medium' },
  { code: TASK_PRIORITIES.HIGH, name: 'High' },
  { code: TASK_PRIORITIES.URGENT, name: 'Urgent' },
];

/**
 * @type {Object}
 */
export const PRIORITIES_VALUES = {
  high: 4,
  low: 2,
  normal: 3,
  urgent: 5,
  watch: 1,
};

/**
 * @type {Object}
 */

export const EXPORT_TYPE = {
  COST: 'cost',
  SUMMARY: 'summary',
  SUPPLY: 'supply',
  PAYROLL: 'payroll',
};

/**
 * @type {Array.<Object>}
 */
export const OVERDUE_STATUSES = [
  TASK_TYPE_STATUS.ASSIGNED,
  TASK_TYPE_STATUS.CREATED,
  TASK_TYPE_STATUS.IN_PROGRESS,
  TASK_TYPE_STATUS.NEW,
];

/**
 * @type {Object}
 */
export const TASK_LIST_TYPE = {
  OFFERS: 'offers',
  TASKS: 'tasks',
};

/**
 * @type {Array}
 */

export const DEPARTMENT_TASK_TYPES = [
  {
    value: 'task-housekeeping',
    label: 'Cleaning',
    code: 'housekeeping',
    icon: 'icon-broom',
    permission: DEPARTMENTS_PERMISSIONS.HOUSEKEEPING.CREATE,
  },
  {
    value: 'task-inspection',
    label: 'Inspection',
    code: 'inspection',
    icon: 'icon-inspection',
    permission: DEPARTMENTS_PERMISSIONS.INSPECTION.CREATE,
  },
  {
    value: 'task-maintenance',
    label: 'Maintenance',
    code: 'maintenance',
    icon: 'icon-maintenance',
    permission: DEPARTMENTS_PERMISSIONS.MAINTENANCE.CREATE,
  },
];

export const ASSIGNMENT_OPTIONS = [
  { value: true, label: 'Default Assignees' },
  { value: false, label: 'Specify Assignee' },
];

export const PRIORITIES_TYPES = [
  { value: 'watch', label: 'Watch' },
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

export const getPriorityTypesWithIcons = () =>
  _.map(PRIORITIES_TYPES, priority => {
    const { value } = priority;

    return {
      ...priority,
      icon: value === TASK_PRIORITIES.NORMAL ? 'medium' : value,
    };
  });

const MAX_ESTIMATE_HOURS = 99;
const MAX_SINGLE_NUMBER = 9;
const SECONDS_AND_COLON_LENGTH = 3;

export const parseEstimatedTime = estimatedTime => {
  const estimatedTimeWithoutSeconds =
    estimatedTime && estimatedTime.substring(0, _.size(estimatedTime) - SECONDS_AND_COLON_LENGTH);
  const splittedTime = _.split(estimatedTimeWithoutSeconds, ':');
  const hours = _.min([_.first(splittedTime), MAX_ESTIMATE_HOURS]);

  return `${hours > MAX_SINGLE_NUMBER ? hours : `0${hours}`}:${_.last(splittedTime)}`;
};

export const getFormattedCalendarDate = (date, time) => {
  const CALENDAR_TIME_FORMAT = 'h:mm A';
  const CALENDAR_FULL_DATE_FORMAT = 'MMM D, h:mm A';
  const defaultTimeValue = time ? `, ${CALENDAR_TIME_FORMAT}` : '';
  const defaultDateValue = `MMM D${time ? `, ${CALENDAR_TIME_FORMAT}` : ''}`;

  // Update moment locale text for task details page
  moment.updateLocale('en', {
    calendar: {
      lastDay: `Yesterday], ${CALENDAR_TIME_FORMAT}`,
      sameDay: '[Today]',
      nextDay: `[Tomorrow], ${CALENDAR_TIME_FORMAT}`,
      lastWeek: CALENDAR_FULL_DATE_FORMAT,
      nextWeek: CALENDAR_FULL_DATE_FORMAT,
      sameElse: CALENDAR_FULL_DATE_FORMAT,
    },
  });

  return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').calendar(null, {
    lastDay: `[Yesterday]${defaultTimeValue}`,
    sameDay: `[Today]${defaultTimeValue}`,
    nextDay: `[Tomorrow]${defaultTimeValue}`,
    lastWeek: defaultDateValue,
    nextWeek: defaultDateValue,
    sameElse: defaultDateValue,
  });
};

/**
 * @param {String} time
 * @return {String}
 */
export const getFormattedEstimatedTime = time => {
  const splittedTime = _.split(time, ':', 2);
  const minutes = _.last(splittedTime);
  const formattedHours = `${_.first(splittedTime)}h`;
  const formattedMinutes = `${minutes !== '00' ? `${minutes}m` : ''}`;

  return `${formattedHours} ${formattedMinutes}`;
};

/**
 * @param {Object} task
 * @return {Moment}
 */
export const getAssignmentTime = task => {
  const assignmentTime = _.get(task, TASK_ASSIGNMENT_TIME_PATH);

  return moment(assignmentTime, TASK_ASSIGNMENT_TIME_FORMAT);
};

/**
 * @param {Object} task
 * @return {Moment}
 */
export const getFinishTime = task => {
  const assignmentTime = _.get(task, TASK_ASSIGNMENT_TIME_PATH);

  return moment(assignmentTime, TASK_ASSIGNMENT_TIME_FORMAT).add(
    TASK_FINISH_TIME_VALUE,
    TASK_FINISH_TIME_UNIT,
  );
};

/**
 * @param {Object} task
 * @param {Object} timeRange
 * @return {Number}
 */
export const getLeftOffset = (task, timeRange) => {
  const { from } = timeRange;

  const assignmentTime = _.get(task, TASK_ASSIGNMENT_TIME_PATH);
  const assignmentTimeMoment = moment(assignmentTime, TASK_ASSIGNMENT_TIME_FORMAT);
  const fromTimeMoment = moment(from, TASK_ASSIGNMENT_TIME_FORMAT);

  const difference = assignmentTimeMoment.diff(fromTimeMoment, 'minutes');

  if (difference >= SCHEDULE_DAILY_TIME_OFFSET_PRECISION) {
    return Math.round(difference / SCHEDULE_DAILY_TIME_OFFSET_PRECISION);
  }

  return 0;
};

/**
 * @param {Object} task
 * @param {Boolean} allDayCell
 * @return {Boolean}
 */
export const shouldSkipTask = (task, allDayCell = false) => {
  const assignmentTime = _.get(task, TASK_ASSIGNMENT_TIME_PATH);

  return (allDayCell && assignmentTime) || (!allDayCell && !assignmentTime);
};

/**
 * @param {String} assignmentTime
 * @param {Object} timeRange
 * @param {String} inclusivity
 * @return {Boolean}
 */
export const isAssignedBetween = (
  assignmentTime,
  timeRange,
  inclusivity = TASK_TIME_INCLUSIVITY,
) => {
  if (assignmentTime && timeRange) {
    const momentAssignmentTime = moment.isMoment(assignmentTime)
      ? assignmentTime
      : moment(assignmentTime, TASK_ASSIGNMENT_TIME_FORMAT);

    const momentFrom = moment(timeRange.from, TASK_ASSIGNMENT_TIME_FORMAT);
    const momentTo = moment(timeRange.to, TASK_ASSIGNMENT_TIME_FORMAT);

    return momentAssignmentTime.isBetween(momentFrom, momentTo, TASK_TIME_SCALE_UNIT, inclusivity);
  }

  return false;
};

/**
 * @param {Object} task
 * @param {Object} timeRange
 * @return {Boolean}
 */
export const isTaskBetweenHours = (task, timeRange) => {
  const assignmentTime = _.get(task, TASK_ASSIGNMENT_TIME_PATH);

  return isAssignedBetween(assignmentTime, timeRange);
};

/**
 * @param {Array.<Object>} tasks
 * @param {Object} timeRange
 * @param {Boolean} allDayCell
 * @return {Array.<Object>}
 */
export const filterTasks = (tasks, timeRange, allDayCell) =>
  _.filter(tasks, task => {
    const notSkipTask = !shouldSkipTask(task, allDayCell);

    if (allDayCell || !timeRange) {
      return notSkipTask;
    }

    return notSkipTask && isTaskBetweenHours(task, timeRange);
  });

/**
 * @param {Object} firstTask
 * @param {Object} lastTask
 * @param {Object} timeRange
 * @return {Number}
 */
export const countTaskRowWidth = (firstTask, lastTask, timeRange) => {
  let dataScheduleWidth = 0;

  _.each(timeRange, timeRangeRow => {
    const assignmentTime = getAssignmentTime(firstTask);
    const finishTime = getFinishTime(lastTask);

    if (
      isAssignedBetween(assignmentTime, timeRangeRow, '[)') ||
      isAssignedBetween(finishTime, timeRangeRow, '(]')
    ) {
      dataScheduleWidth += 1;
    }
  });

  return dataScheduleWidth || TASK_ROW_DEFAULT_WIDTH;
};

/**
 * @param {Object} task
 * @param {Object} timeRange
 * @param {Object} currentTimeRange
 * @return {Object}
 */
export const getTaskRowProps = (task, timeRange, currentTimeRange) => {
  // only look at start time for now
  const assignmentTime = getAssignmentTime(task);
  const taskTimes = [];

  _.each(timeRange, timeRangeRow => {
    if (isAssignedBetween(assignmentTime, timeRangeRow)) {
      taskTimes.push(timeRangeRow);
    }
  });

  const firstTaskTime = _.head(taskTimes);
  const lastTaskTime = _.last(taskTimes);

  const isFirst =
    currentTimeRange.from <= firstTaskTime.from && currentTimeRange.to >= firstTaskTime.to;

  const isLast =
    taskTimes.length > 0 &&
    currentTimeRange.from <= lastTaskTime.from &&
    currentTimeRange.to >= lastTaskTime.to;

  return {
    first: isFirst,
    last: isLast,
    existing: taskTimes,
  };
};

/**
 * @param {Object} task
 * @return {Array.<Object>}
 */
export const getAssignedPeople = task => _.get(task, 'people', []);

/**
 * @param {Object} task
 * @return {Number}
 */
export const getAssignedPeopleSize = task => _.size(_.get(task, 'people', []));

/**
 * @param {Object} taskOffer
 * @return {String}
 */
export const getAssignedCompanyStatus = taskOffer =>
  _.get(taskOffer, 'assigned_company.type_task_user_status.code', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getDepartmentCode = task => _.get(task, 'type_department.code', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getTypeStatusCode = task => _.get(task, 'type_task_status.code', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getPriorityCode = task => _.get(task, 'type_priority.code', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getTypeStatusName = task => _.get(task, 'type_task_status.name', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getTypeStatusStage = task => _.get(task, 'type_task_status.stage', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getPropertyName = task => _.get(task, 'home.name', null);

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const getPausedStatus = task => _.get(task, 'paused', false);

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isDraft = task => _.get(task, 'draft', false);

/**
 * @param {Object} task
 * @return {String}
 */
export const getTotalTime = task => _.get(task, 'timing_current_total_time', '');

/**
 * @param {Object} task
 * @return {String}
 */
export const getCurrentTaskTime = task => _.get(task, 'timing.total_time');

/**
 * @param {Object} task
 * @return {String}
 */
export const getEstimate = task => _.get(task, 'estimate');

/**
 * @param {Object} task
 * @return {String}
 */
export const getEstimatedTime = task => _.get(task, 'estimate.estimated_time', '');

/**
 * @param {Object} task
 * @return {Number}
 */
export const getTaskSeriesId = task => _.get(task, 'task_series_id', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getTaskName = task => _.get(task, 'name');

/**
 * @param {Object} task
 * @return {Object}
 */
export const getTaskHome = task => _.get(task, 'home');

/**
 * @param {Object} task
 * @return {String}
 */
export const getStartTime = task => _.get(task, 'start_time', '');

/**
 * @param {Object} task
 * @return {Number}
 */
export const getTaskHomeId = task => _.get(task, 'home.id', null);

/**
 * @param {Object} task
 * @return {String}
 */
export const getLifeStatus = task => {
  const statusType = _.get(task, 'type_task_status.stage');
  const assignmentDate = _.get(task, 'start_date');
  const assignedPeople = getAssignedPeople(task);

  if (statusType === SINGLE_TASK_LIFE_STATUS.FINISHED) {
    return SINGLE_TASK_LIFE_STATUS.FINISHED;
  }

  if (moment(assignmentDate).isBefore(moment(), 'day')) {
    return SINGLE_TASK_LIFE_STATUS.OVERDUE;
  }

  if (statusType === SINGLE_TASK_LIFE_STATUS.IN_PROGRESS) {
    return SINGLE_TASK_LIFE_STATUS.IN_PROGRESS;
  }

  if (_.size(assignedPeople) > 0) {
    return SINGLE_TASK_LIFE_STATUS.ASSIGNED;
  }

  return SINGLE_TASK_LIFE_STATUS.UNASSIGNED;
};

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskInProgress = task =>
  getTypeStatusCode(task) === SINGLE_TASK_LIFE_STATUS.IN_PROGRESS;

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskCompleted = task => getLifeStatus(task) === SINGLE_TASK_LIFE_STATUS.FINISHED;

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskPaused = task => isTaskInProgress(task) && getPausedStatus(task);

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskRunning = task => !getPausedStatus(task) && isTaskInProgress(task);

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskStarted = task => !isTaskCompleted(task) && isTaskRunning(task);

/**
 * @param {Object} task
 * @return {Boolean}
 */
export const isTaskInWorkflow = task =>
  _.has(task, 'scheduled_workflow_task.scheduled_workflow_id');

/**
 * @param {Object} task
 * @return {Object}
 */
export const getTaskCompany = task => _.get(task, 'company');

/**
 *
 */
export const getAssignmentPeopleStatus = (people, type) => {
  _.some(people, taskPerson => _.get(taskPerson, 'type_task_user_status.code') === type);
};

export const PERIODS = {
  HOURS: 'hours',
  MINUTES: 'minutes',
};

/**
 *
 */
export const getFilterStatuses = task => {
  const taskStatus = _.get(task, 'type_task_status.code');
  const taskIsPaused = _.get(task, 'paused', false);
  const taskAssignments = getAssignedPeople(task);

  const statuses = [];

  if (taskStatus) {
    if (_.size(taskAssignments) === 0) {
      statuses.push('notAssigned');
    } else if (taskStatus === 'new') {
      statuses.push('assigned');
    }

    if (_.isEqual(taskStatus, TASK_TYPE_STATUS.CREATED)) {
      statuses.push('not_started');
    }

    if (taskIsPaused) {
      statuses.push('paused');
    }

    if (_.includes(OVERDUE_STATUSES, taskStatus)) {
      const assignmentDate = _.get(task, 'start_date');
      const overdue = assignmentDate && moment(assignmentDate).isBefore(moment(), 'day');
      if (overdue) {
        statuses.push('overdue');
      }
    }

    statuses.push(taskStatus);
  }

  return statuses;
};

/**
 * @param {Object} task
 * @param {Array.<String>} statusFilters
 * @return {Boolean}
 */
export const shouldTaskStatusDisplay = (task, statusFilters) => {
  const taskStatus = _.get(task, 'type_task_status.code');
  if (_.includes(statusFilters, taskStatus)) {
    return true;
  }
  if (_.includes(statusFilters, 'paused') && _.get(task, 'paused', false)) {
    return true;
  }
  if (_.includes(statusFilters, 'notAssigned') && _.size(_.get(task, 'people', [])) === 0) {
    return true;
  }
  if (_.includes(statusFilters, 'assigned') && _.size(_.get(task, 'people', [])) > 0) {
    return true;
  }
  if (_.includes(statusFilters, 'overdue') && _.includes(OVERDUE_STATUSES, taskStatus)) {
    const assignmentDate = _.get(task, 'start_date');
    const overdue = assignmentDate && moment(assignmentDate).isBefore(moment(), 'day');
    if (overdue) {
      return true;
    }
  }
  if (_.includes(statusFilters, 'draft') && _.get(task, 'draft', false)) {
    return true;
  }
  if (_.includes(statusFilters, 'not_started') && _.isEqual(taskStatus, TASK_TYPE_STATUS.CREATED)) {
    return true;
  }

  return false;
};

/**
 * @param {Object} task
 * @param {Array.<String>} statusFilters
 * @return {Boolean}
 */
export const shouldTaskPriorityDisplay = (task, statusFilters) => {
  const taskStatus = _.get(task, 'type_priority.code');
  return _.includes(statusFilters, taskStatus);
};

export const shouldTaskAssignmentDisplay = (task, assignmentFilters) => {
  const taskPeople = _.get(task, 'people', []);

  if (_.includes(assignmentFilters, 'notAssigned') && _.size(taskPeople) === 0) {
    return true;
  }

  if (_.includes(assignmentFilters, 'assigned') && _.size(taskPeople) > 0) {
    return true;
  }

  if (
    _.size(
      _.intersection(
        assignmentFilters,
        _.map(taskPeople, taskPerson => taskPerson.company_people_id),
      ),
    ) > 0
  ) {
    return true;
  }

  return false;
};

export const shouldTaskAssignmentStatusDisplay = (task, assignmentStatusFilters) => {
  const taskAssignmentsStatuses = _.map(_.get(task, 'people', []), person =>
    _.get(person, 'type_task_user_status.code'),
  );
  if (
    _.isEmpty(taskAssignmentsStatuses) &&
    _.includes(assignmentStatusFilters, TASK_ASSIGNMENT_STATUS.UNASSIGNED)
  ) {
    return true;
  }
  return !_.isEmpty(_.intersection(assignmentStatusFilters, taskAssignmentsStatuses));
};

/**
 * @param {Array.<Object>} tasks
 * @return {Object}
 */
export const groupTasks = tasks => {
  const workflows = {};
  const singleTasks = [];

  _.forEach(tasks, task => {
    const isWorkflowTask = isTaskInWorkflow(task);

    if (isWorkflowTask) {
      const workflowId = _.get(task, 'scheduled_workflow_task.scheduled_workflow_id', 0);
      const isWorkflowInitialized = _.has(workflows, workflowId);

      if (!isWorkflowInitialized) {
        workflows[workflowId] = [];
      }

      workflows[workflowId].push(task);
    } else {
      singleTasks.push(task);
    }
  });

  return {
    singleTasks,
    workflows,
  };
};

/**
 * @description Sorting by criteria:
 *  1) By time (day/time)
 *  2) By priority
 *  3) By task name
 * @param {Array.<Object>} tasks
 * @return {Array.<Object>}
 */
export const sortTasks = tasks =>
  _.orderBy(
    tasks,
    task => {
      const date = _.get(task, TASK_SCHEDULE_DATE_PATH, null);
      const time = _.get(task, TASK_SCHEDULE_TIME_PATH) || 24;
      const priority = _.get(task, 'type_priority.code', null);
      const name = _.get(task, 'name', null);
      const address = _.get(task, 'home.address1', priority, 0);

      return [time, date, address, name];
    },
    ['asc', 'asc', 'asc', 'asc'],
  );

export const STATUS_TYPES = [
  { code: 'draft', name: 'Draft' },
  { code: 'created', name: 'Not Started' },
  { code: 'in_progress', name: 'In Progress' },
  { code: 'finished', name: 'Finished' },
  { code: 'closed', name: 'Closed' },
  { code: 'approved', name: 'Approved' },
  { code: 'overdue', name: 'Overdue' },
];

const statusTypesFromAPI = () => {
  const newStatusTypes = _.clone(STATUS_TYPES);
  const index = _.findIndex(newStatusTypes, type => type.code === 'created');
  if (_.get(newStatusTypes, [index, 'code'])) newStatusTypes[index].code = 'not_started';
  return newStatusTypes;
};

export const STATUS_TYPES_FROM_API = statusTypesFromAPI();

// Filters
const departmentFilter = (task, departments) => {
  if (_.includes(departments, 'hasTask')) {
    return true;
  }
  return _.includes(departments, _.get(task, 'type_department.code', ''));
};

const assignmentFilter = (task, assignments) => shouldTaskAssignmentDisplay(task, assignments);
const assignmentStatusFilter = (task, assignmentStatuses) =>
  shouldTaskAssignmentStatusDisplay(task, assignmentStatuses);
const statusFilter = (task, statuses) => shouldTaskStatusDisplay(task, statuses);
const priorityFilter = (task, priorities) =>
  _.includes(priorities, _.get(task, 'type_priority.code'));
const requestedByFilter = (task, requestedBy) =>
  _.includes(requestedBy, _.get(task, 'type_task_requester.code'));

const FILTER_MAP = {
  assignments: assignmentFilter,
  assignmentStatus: assignmentStatusFilter,
  departments: departmentFilter,
  priorities: priorityFilter,
  requested_by: requestedByFilter,
  statuses: statusFilter,
};
export const VALID_TASK_FILTERS = _.keys(FILTER_MAP);

export const shouldTaskBeFiltered = (task, filters, propertyIds = null) => {
  if (!_.isNull(propertyIds) && !_.includes(propertyIds, task.home_id)) {
    return true;
  }

  return !_.every(filters, filter => FILTER_MAP[filter.filterName](task, filter.values));
};

export const getTaskStatus = task => {
  const status = _.get(task, 'type_task_status.stage');
  if (_.isEqual(status, SINGLE_TASK_LIFE_STATUS.FINISHED)) {
    return SINGLE_TASK_LIFE_STATUS.FINISHED;
  }

  const assignmentDate = _.get(task, 'start_date');
  if (moment(assignmentDate).isBefore(moment(), 'day')) {
    return SINGLE_TASK_LIFE_STATUS.OVERDUE;
  }

  if (_.get(task, 'paused')) {
    return 'isPaused';
  }

  if (_.isEqual(status, SINGLE_TASK_LIFE_STATUS.IN_PROGRESS)) {
    return 'isStarted';
  }

  return !_.isEmpty(_.get(task, 'people'))
    ? SINGLE_TASK_LIFE_STATUS.ASSIGNED
    : SINGLE_TASK_LIFE_STATUS.UNASSIGNED;
};
